
import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useState } from 'react';

function ExternalChannels(props) {

    const getText = usePJStore((state) => state.i18n_getText)

    const [loading, setLoading] = useState(false);
    const [channels, setChannels] = useState([])
    const [allChannels, setAllChannels] = useState([])
    const { storage } = usePJStore((state) => state.storage)


    const [newDialogVisible, setNewDialogVisible] = useState(false)

    const [channelIds, setChannelIds] = useState([])
    const [chiavi, setChiavi] = useState([])
    const [valori, setValori] = useState([])

    const [deleteRequest, setDeleteRequest] = useState(null);


    const [selectedChannelId, setSelectedChannelId] = useState(null)
    const [selectedChiave, setSelectedChiave] = useState(null)
    const [selectedValore, setSelectedValore] = useState(null)

    useEffect(() => {
        if (props.selectedNode != null) {

            PJAxios().post('/chatbot/getExternalContactLinks', { idNode: props.selectedNode.elemento_id }).then((res) => {
                setChannels(res.data.channels);
            })

        }

    }, [props.selectedNode]);

    const channelIdTemplate = (rowData) => {
        return getText(rowData.channel_id)
    }

    let emptyChannel = {
        id: null,
        name: '',
        image: null,
        description: '',
        category: null,
        price: 0,
        quantity: 0,
        rating: 0,
        inventoryStatus: 'INSTOCK'
    };

    const openNewDialog = () => {

        PJAxios().post('/chatbot/getExternalContactLinks', { idNode: null }).then((res) => {
            setAllChannels(res.data.channels)
            setChannelIds([...new Set(res.data.channels.map(item => item.channel_id))])

        })

        setNewDialogVisible(true)
    }

    useEffect(() => {
        setChiavi([...new Set(allChannels.filter(channel => channel.channel_id == selectedChannelId).map(item => item.chiave))])
        setValori([...new Set(allChannels.filter(channel => channel.channel_id == selectedChannelId).map(item => item.valore))])
    }, [selectedChannelId]);

    useEffect(() => {
        setValori([...new Set(allChannels.filter(channel => channel.channel_id == selectedChannelId).filter(channel => channel.chiave == selectedChiave).map(item => item.valore))])
    }, [selectedChiave]);


    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label={getText("AGGIUNGI")} icon="pi pi-plus" onClick={openNewDialog} severity="success" />
            </div>
        );
    };


    const deleteChannel = (event) => {

        var request = {
            idItem: event.id_item,
            channelId: event.channel_id,
            chiave: event.chiave,
            valore: event.valore
        };

        PJAxios().post('/chatbot/deleteExternalContactLink', request).then((res) => {
            if (res.data) {
                PJAxios().post('/chatbot/getExternalContactLinks', { idNode: props.selectedNode.elemento_id }).then((res) => {
                    setChannels(res.data.channels);
                })
            }
        });
    }

    const reject = () => {

    };

    const confirmOperation = (event) => {

        confirmPopup({
            target: event.currentTarget,
            message: getText("CONFERMA_OPERAZIONE"),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => deleteChannel(event),
            reject: reject
        });
    };
    const actionBodyTemplate = (rowData) => {
        return (
            <table>
                <tr>
                    <td>
                        <Button id={rowData.channel_id} label={getText("CANCELLA")} icon="pi pi-trash" onClick={() => { confirmOperation(rowData, getText("CONFERMA_OPERAZIONE")) }} />
                    </td>
                </tr>
            </table>

        );
    }

    const addItem = () => {
        PJAxios().post('/chatbot/addExternalContactLink', 
        {
            idItem: props.selectedNode.elemento_id,
            channelId: selectedChannelId,
            chiave: selectedChiave,
            valore: selectedValore
        }

        ).then((res) => {
            if (res.data) {
                setNewDialogVisible(false)
                
                PJAxios().post('/chatbot/getExternalContactLinks', { idNode: props.selectedNode.elemento_id }).then((res) => {
                    setChannels(res.data.channels);
                })
            }
        });
    }

    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&

                <>
                    <ConfirmPopup />
                    <Card className="surface-hover col-12 md:col-12" >
                        <Toolbar className="mb-4" left={leftToolbarTemplate} ></Toolbar>
                        <DataTable value={channels} size='small'  paginator rows={7} rowsPerPageOptions={[5, 7, 10]} >
                            <Column field="channel_id" header={getText("CHANNEL_ID")} body={channelIdTemplate}></Column>
                            <Column field="chiave" header={getText("KEY")} sortable style={{ minWidth: '12rem' }}></Column>
                            <Column field="valore" header={getText("VALUE")} sortable style={{ minWidth: '12rem' }}></Column>
                            <Column body={actionBodyTemplate} />

                        </DataTable>
                    </Card>
                    <Dialog visible={newDialogVisible} style={{ width: '80%' }} header={getText("NEW_EXTERNAL_CONTACT")} modal className="p-fluid" onHide={() => setNewDialogVisible(false)}>
                        <div>
                            <div className='formgroup-inline'>
                                <div className='col-6'>
                                    {getText("SELECT_CHANNEL_ID")}
                                </div>
                                <div className='col-6'>
                                    <Dropdown options={channelIds} value={selectedChannelId} onChange={(e) => setSelectedChannelId(e.value)} />

                                </div>
                            </div>
                            <div className='formgroup-inline'>
                                <div className='col-6'>
                                    {getText("SELECT_KEY")}
                                </div>
                                <div className='col-6'>
                                    <Dropdown options={chiavi} value={selectedChiave} onChange={(e) => setSelectedChiave(e.value)} />

                                </div>
                            </div>
                            <div className='formgroup-inline'>
                                <div className='col-6'>
                                    {getText("SELECT_VALUE")}
                                </div>
                                <div className='col-6'>
                                    <Dropdown options={valori} value={selectedValore} onChange={(e) => setSelectedValore(e.value)} />

                                </div>
                            </div>
                            <div className='formgroup-inline'>
                                <div className='col-3'>
                                    <Button label={getText("AGGIUNGI")} onClick={addItem} />
                                </div>
                            </div>

                        </div>

                    </Dialog>
                </>




            }
        </>
    )
}

export default ExternalChannels
